import React from 'react';
import { Modal, Button } from 'antd';
import { useStoreState } from '../../store';
import { ReactComponent as Logo } from '~/assets/logo-dark.svg';
import { Flex } from '../../components/Flex';
export const MODAL_KEY = 'newVersionAvailable';

export const NewVersionAvailableModal = () => {
  const versionMetadata = useStoreState((state) => state.session.versionMetadata);
  const open = !!(versionMetadata?.version && process.env.REACT_APP_VERSION !== versionMetadata?.version);

  const handleUpdate = () => {
    window.location.reload();
  };

  const title = (
    <Flex direction="vertical" alignItems="center" gap="sm">
      <Logo style={{ width: 120, height: 'auto' }} />
      <span>Application Update Required</span>
    </Flex>
  );
  const updateButton = (
    <Button type={'primary'} onClick={handleUpdate}>
      Click Here to Update
    </Button>
  );

  return (
    <Modal title={title} open={open} footer={updateButton} onCancel={handleUpdate} closable={false}>
      <h3>
        Version <b>v.{versionMetadata?.version}</b> of the Shipium Console is available.
      </h3>
      <h4>Click the button below to continue your current session.</h4>
    </Modal>
  );
};
